import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M8 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0-4.75 6.062 3.375v6.75L8 14.75l-6.062-3.375v-6.75L8 1.25Zm0 1.145L2.938 5.213v5.574L8 13.605l5.062-2.818V5.213L8 2.395Z" />
    </svg>
  )
}

const Setting = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
Setting.defaultProps = {
  width: 16,
  height: 16,
  // fill: 'rgba(0,0,0,0.40)',
}
// 参数类型
Setting.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default Setting
